import React from 'react'
import { Container, Typography } from '@cleartrip/ct-design-components'
import FlightDetailsDeparture from '@/assets/icons/FlightDetailsDeparture'
import FlightDetailsArrival from '@/assets/icons/FlightDetailsArrival'
import { getFormattedDate } from '@/utils/general/date'

interface ArrivalDepartInfoProps {
    airport: any
    airportDetail: any
    isLast?: boolean
    isTripStart?: boolean
    isTripEnd?: boolean
    isFirst?: boolean
    type: 'departure' | 'arrival'
}

const ArrivalDepartInfo = ({
    airport = {},
    airportDetail = {},
    isLast = false,
    isTripStart = false,
    isTripEnd = false,
    isFirst = false,
    type = 'departure'
}: ArrivalDepartInfoProps) => {
    const { code = '', terminal = {}, time = '' } = airport || {}
    const { name = '' } = terminal || {}
    const airportData = airportDetail?.[code] || {}
    return (
        <Container className="flex flex-middle">
            <Container style={{ width: '60px' }}>
                <Container className="flex flex-column flex-bottom">
                    <Typography variant="HM2">{getFormattedDate(time, 'HH:mm', 'YYYY-MM-DDTHH:mm:ss')}</Typography>
                </Container>
            </Container>
            <Container className="flex flex-center" style={{ width: '43px' }}>
                {type === 'departure' ? (
                    <FlightDetailsDeparture isLast={isLast} isTripStart={isTripStart} />
                ) : (
                    <FlightDetailsArrival isTripEnd={isTripEnd} isFirst={isFirst} />
                )}
            </Container>
            <Container className="ml-4">
                <Typography variant="HM3" className="mb-1">
                    {airportData?.city} ({airportData?.code})
                </Typography>
                <Typography variant="P2">
                    {airportData?.name}, Terminal {name}
                </Typography>
            </Container>
        </Container>
    )
}

export default ArrivalDepartInfo
